import Reflux from 'reflux';
import UserActions from 'actions/user-actions';
import SystemActions from 'actions/system-actions';
import { getSessionAccount, getbigConfig } from 'api/api';
import { isEmpty, get } from 'lodash';
import { hashHistory } from 'react-router';
import Tools from 'utils/tools';

class UserStores extends Reflux.Store {
  constructor() {
    super();
    this.listenables = UserActions;
    const userInfo = Tools.getCookie('userInfo');
    this.state = {
      userInfo: userInfo ? JSON.parse(userInfo) : {},
      isAjax: false
    };
  }

  onGetUserInfo(cb, fail,loginConfigId) {
    if (isEmpty(this.state.userInfo)) {
      if (this.state.isAjax) return;
      this.setState({
        isAjax: true
      });
      // 如果有大屏配置信息需要两个ajax都返回才登录OK，其中任意一个没有返回则登录失败；没有大屏配置信息则只请求账号信息
      if(loginConfigId) {
        Promise.all([getSessionAccount(), getbigConfig({loginConfigId})])
        .then(values => {
          const userInfo = get(values, "[0].data", {});
          this.setState({
            userInfo,
            isAjax: false
          });
          // 设置过期时间4小时 3.9
          Tools.setCookie(
            'userInfo',
            JSON.stringify(userInfo),
            3.9 * 3600 * 1000
            // 8000
          );
          const bigConfig = get(values, "[1].data", {});
          const hoverColor = Tools.getHoverColor(bigConfig.customSystemColor);
          const link = document.querySelector("link[rel*='icon']");
          let titleLogoUrl, firstTitleName;
          if (link) {
            titleLogoUrl = link.href.substring(0,link.href.indexOf("?")===-1?link.href.length:link.href.indexOf("?"));
            firstTitleName = document.title;
          }
          sessionStorage.setItem(
            "bigConfig",
            JSON.stringify({...bigConfig, hoverColor, titleLogoUrl, firstTitleName})
          );
          cb && cb(userInfo);
        })
        .catch(() => {
          this.setState({
            isAjax: false
          });
          fail && fail();
          this.onClearUserInfo(() => {
            hashHistory.replace('/farm');
          });
        })
      } else {
        getSessionAccount()
          .then(res => {
            const userInfo = res.data;
            this.setState({
              userInfo,
              isAjax: false
            });
            // 设置过期时间4小时 3.9
            Tools.setCookie(
              'userInfo',
              JSON.stringify(userInfo),
              3.9 * 3600 * 1000
              // 8000
            );
            cb && cb(userInfo);
          })
          .catch(() => {
            this.setState({
              isAjax: false
            });
            fail && fail();
            this.onClearUserInfo(() => {
              hashHistory.replace('/farm');
            });
          });
      }
    } else {
      cb && cb(this.state.userInfo);
    }
  }

  onClearUserInfo(cb) {
    console.log('退出登录:清理账号信息');
    Tools.delCookie('userInfo');
    sessionStorage.clear();
    // sessionStorage.removeItem('allAuthArray');
    // sessionStorage.removeItem('allAuthCodePrentId');
    // sessionStorage.removeItem('allAuthCodeObj');
    // sessionStorage.removeItem('bigConfig');
    SystemActions.clearCurrentMechanism();
    this.setState({
      userInfo: {}
    });
    cb && cb();
  }
}

export default UserStores;
